import { Theme } from "@mui/material";
import { colors, hoverColors } from '../../constants/colors';

const styles = {
  backgroundColor: 'transparent',
  position: 'fixed',
  paddingTop: '0',
  boxShadow: 'none',
  zIndex: 1000,
  color: colors.white,
  borderBottom: `1px solid rgba(255,255,255,.5)`,
  transition:  '0.32s background-color ease-in-out, 0.32s box-shadow ease-in-out',
  '& #navbar-logo': {
    transition: '0.32s opacity ease-in-out',
  },
  '& .logoScrolledIn': {
    opacity: 1,
  },
  '& .logoScrolledOut': {
    opacity: 0,
  },
  '& #contact-ribbon': {
    background: colors.black,
    '& a': {
      color: colors.white,
    }
  },
  '& .MuiButtonBase-root': {
    textTransform: 'none'
  },
  '& .MuiButtonBase-root#navbar-menu-button': {
    fontWeight: 300,
    color: colors.white,
    '&:hover': {
      backgroundColor: hoverColors.primary,
      color: colors.white
    }
  },
  '& .innerContainerScrolled': {
    // paddingTop: '2px',
  },
  '&.scrolled': {
    // paddingBottom: '4px',
    backgroundColor: 'hsl(0, 0%, 99%, 1)',
    boxShadow: '0 0 28px hsla(0,0%,50%,.5)',
    
    '& .MuiButtonBase-root#navbar-menu-button': {
      color: colors.black,
      '&:hover': {
        color: colors.white
      }
    },
    '& #navbar-logo-container': {
      color: colors.black
    },
    '& .MuiSvgIcon-root': {
      color: colors.black
    },
    '& .MuiBox-root > a':{
      textShadow: 'none'
    }
  },
  '@media (min-width: 370px)': {
    '& #navbar-logo-container': {
      fontSize: '1.5rem'
    }
  },
  '@media (min-width: 1200px)': {
    '& #menu-appbar': {
      display: 'hidden !important'
    }
  }
};

const navbarStyles: any = (theme?: Theme) => styles;

export default navbarStyles;